import React from 'react';
import { FaFont, FaAlignLeft, FaAlignJustify, FaPalette, FaBold, FaItalic } from 'react-icons/fa';
import './TextEditor.css';

const TextEditor = ({ cardText, setCardText }) => {
  const handleTextChange = (field, value) => {
    setCardText(prev => ({
      ...prev,
      [field]: value
    }));
  };

  return (
    <div className="text-editor">
      <div className="editor-header">
        <h3>文字设置</h3>
      </div>

      <div className="editor-section">
        <label className="editor-label">
          <FaFont className="icon" />
          文字内容
        </label>
        <textarea
          value={cardText.content}
          onChange={(e) => handleTextChange('content', e.target.value)}
          placeholder="在此输入您的文字..."
          className="text-input"
          rows="3"
        />
      </div>

      <div className="editor-section">
        <label className="editor-label">
          <FaFont className="icon" />
          字体选择
        </label>
        <div className="font-buttons">
          <button
            className={`font-btn ${cardText.fontFamily === 'PangMenZhengDao' ? 'active' : ''}`}
            onClick={() => handleTextChange('fontFamily', 'PangMenZhengDao')}
          >
            庞门正道粗书体
          </button>
          <button
            className={`font-btn ${cardText.fontFamily === 'SourceHanSerif' ? 'active' : ''}`}
            onClick={() => handleTextChange('fontFamily', 'SourceHanSerif')}
          >
            思源宋体
          </button>
          <button
            className={`font-btn ${cardText.fontFamily === 'Playfair Display' ? 'active' : ''}`}
            onClick={() => handleTextChange('fontFamily', 'Playfair Display')}
          >
            Playfair Display
          </button>
          <button
            className={`font-btn ${cardText.fontFamily === 'Montserrat' ? 'active' : ''}`}
            onClick={() => handleTextChange('fontFamily', 'Montserrat')}
          >
            Montserrat
          </button>
          <button
            className={`font-btn ${cardText.fontFamily === 'Dancing Script' ? 'active' : ''}`}
            onClick={() => handleTextChange('fontFamily', 'Dancing Script')}
          >
            Dancing Script
          </button>
          <button
            className={`font-btn ${cardText.fontFamily === 'Roboto' ? 'active' : ''}`}
            onClick={() => handleTextChange('fontFamily', 'Roboto')}
          >
            Roboto
          </button>
          <button
            className={`font-btn ${cardText.fontFamily === 'Merriweather' ? 'active' : ''}`}
            onClick={() => handleTextChange('fontFamily', 'Merriweather')}
          >
            Merriweather
          </button>
        </div>
      </div>
      <div className="editor-section">
        <label className="editor-label">
          <FaAlignJustify className="icon" />
          书写模式
        </label>
        <div className="writing-mode-buttons">
          <button
            className={`writing-mode-btn ${cardText.writingMode === 'horizontal' ? 'active' : ''}`}
            onClick={() => handleTextChange('writingMode', 'horizontal')}
            title="水平书写"
          >
            <FaAlignLeft className="mode-icon" />
            水平
          </button>
          <button
            className={`writing-mode-btn ${cardText.writingMode === 'vertical' || !cardText.writingMode ? 'active' : ''}`}
            onClick={() => handleTextChange('writingMode', 'vertical')}
            title="垂直书写"
          >
            <FaAlignJustify className="mode-icon" />
            垂直
          </button>
        </div>
      </div>
      <div className="editor-section">
        <label className="editor-label">
          <FaBold className="icon" />
          字体样式
        </label>
        <div className="style-buttons">
          <button
            className={`style-btn ${cardText.fontWeight === 'bold' ? 'active' : ''}`}
            onClick={() => handleTextChange('fontWeight', cardText.fontWeight === 'bold' ? 'normal' : 'bold')}
            title="粗体"
          >
            <FaBold className="style-icon" />
            粗体
          </button>
          <button
            className={`style-btn ${cardText.fontStyle === 'italic' ? 'active' : ''}`}
            onClick={() => handleTextChange('fontStyle', cardText.fontStyle === 'italic' ? 'normal' : 'italic')}
            title="斜体"
          >
            <FaItalic className="style-icon" />
            斜体
          </button>
        </div>
      </div>
      <div className="editor-section">
        <label className="editor-label">
          <FaPalette className="icon" />
          文字颜色
        </label>
        <div className="color-buttons">
          <button
            className={`color-btn ${cardText.color === '#ffffff' ? 'active' : ''}`}
            onClick={() => handleTextChange('color', '#ffffff')}
            title="白色"
          >
            <div className="color-preview white"></div>
            白色
          </button>
          <button
            className={`color-btn ${cardText.color === '#000000' ? 'active' : ''}`}
            onClick={() => handleTextChange('color', '#000000')}
            title="黑色"
          >
            <div className="color-preview black"></div>
            黑色
          </button>
          <button
            className={`color-btn ${cardText.color === '#a0a0a0' ? 'active' : ''}`}
            onClick={() => handleTextChange('color', '#a0a0a0')}
            title="灰色"
          >
            <div className="color-preview gray"></div>
            灰色
          </button>
        </div>
      </div>





      <div className="editor-section">
        <button
          className="reset-btn"
          onClick={() => setCardText(prev => ({
            content: '小时候回外婆家过年，那是大别山深处的一个小村子，尽管山清水秀，但很穷。不过，春节前，村里家家都会做两样东西，一个是年糕，一个是腊肉。——《吃着吃着就老了》',
            color: '#ffffff',
            fontFamily: 'SourceHanSerif',
            writingMode: 'horizontal',
            textAlign: 'justify',
            fontWeight: 'bold',
            fontStyle: 'normal'
            // 移除position，让CardCanvas根据书写模式自动设置位置
          }))}
        >
          重置文字
        </button>
      </div>
    </div>
  );
};

export default TextEditor;
